import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { endPoint } from "constants/server/api";
import { createFetchLogicPrototype } from "../../utils/fetchFactory";
import { createSlicePrototype } from "../../utils/sliceFactory";
import { http } from "utils/http";
import { buildQueryParams } from "utils/HelperFunction";
var getAllNewSoSlice = createSlicePrototype({
    name: "getAllNewSo"
});
export var getAllNewSo = createFetchLogicPrototype({
    actions: getAllNewSoSlice.actions,
    configFn: function(param, param1) {
        var queryParams = param.queryParams, accessToken = param1.accessToken;
        var url = endPoint.NEW_SO;
        var queryString = buildQueryParams({
            paramsObj: queryParams
        });
        url = "".concat(url, "?").concat(queryString);
        return {
            method: "get",
            url: url,
            headers: {
                Authorization: "Bearer ".concat(accessToken)
            }
        };
    },
    onError: function(error, param) {
        var modalObj = param.modalObj, setModalObj = param.setModalObj;
        var getStatus = function(err) {
            return http.isAxiosError(err) && err.response ? err.response.status : 500;
        };
        var getMessage = function(err) {
            return http.isAxiosError(err) && err.response ? err.response.data.message : "เกิดข้อผิดพลาด\nหรือเครือข่ายขัดข้อง";
        };
        setModalObj === null || setModalObj === void 0 ? void 0 : setModalObj(_object_spread_props(_object_spread({}, modalObj), {
            visible: true,
            subTitle: "รหัส ".concat(getStatus(error)),
            navigateDirection: undefined,
            title: getMessage(error)
        }));
    }
});
export var clearGetAllNewSo = function() {
    return function(dispatch) {
        dispatch(getAllNewSoSlice.actions.resetState());
    };
};
var _getAllNewSoSlice_actions = getAllNewSoSlice.actions;
export var fetchData = _getAllNewSoSlice_actions.fetchData, fetchDataSuccess = _getAllNewSoSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllNewSoSlice_actions.fetchDataFailure, resetState = _getAllNewSoSlice_actions.resetState;
export default getAllNewSoSlice.reducer;
